import React from "react"
import { GridItem, VStack } from "@chakra-ui/react"
import Post from "./Post"
import ShowAllButton from "./ShowAllButton"

export default function Feed({
  showAllPosts,
  activeTags,
  postLimit,
  posts,
  bp,
}) {
  const buttonProps = {
    showAllPosts,
    postLimit,
  }

  return (
    <GridItem
      colSpan={{ base: 5, [bp]: 3 }}
      as={VStack}
      spacing={8}
      ml="auto"
      flex={1}
      w="full"
      py={2}
    >
      {posts
        .slice(0, postLimit ? postLimit : posts.length)
        .map((node, index) => {
          if (activeTags.length === 0) {
            return <Post key={index} {...node} />
          }

          if (activeTags.includes(node.frontmatter.tag)) {
            return <Post key={index} {...node} />
          }
        })}
      <ShowAllButton {...buttonProps} />
    </GridItem>
  )
}
